export const getFormattedGrid = (grid: string) => {
    return grid.replace(/^(.{4})(.{4})(.{4})(.{4})(.*)$/, '$1 $2 $3 $4 $5');
};

export const getFormattedPatientId = (rid: string | undefined) => {
    return rid?.replace(/(\d{3})(\d{3})(\d{1})/, '$1-$2-$3');
};
